<template>
	<div>
		<div
			class="modal fade"
			id="detailedScopeData"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">{{target}}</h5>
						<button type="button" class="close" data-dismiss="modal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div v-for = "item in data">
							<p>{{item.name ? item.name : (item.type == 'add asin' ? item.asin : (item.product_title ? item.product_title : item.asin))}}</p>
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ShowDetailedScope",
		components: {
		},
		mounted() {
			//this.openCampaignGroup();
		},
		props:["target", "data"],
		data() {
			return {

			};
		},
		watch: {},
		methods: {}

	};
</script>
<style lang="scss">
</style>
